module.exports = __webpack_public_path__ + "img/7.b70441a7.png";